import { notification } from 'antd'
import { getEnvironment } from 'config/environment/appConfig'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isoWeek from 'dayjs/plugin/isoWeek'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { rootStore } from 'store/root'
import { Provider } from 'store/useStore'
import { AdminMenuUiStateProvider } from 'states/AdminMenuUiState/AdminMenuUiStateProvider'
import { PromoPageStateProvider } from 'states/PromoPageState/PromoPageStateProvider'
import { UserStateProvider } from 'states/UserState/UserStateProvider'

import 'config/i18n/i18n'
import App from './App'

import './assets/fonts/fonts.scss'

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(isoWeek)
dayjs.locale('ru')

notification.config({
  placement: 'bottomRight',
  duration: 5,
})

const env = getEnvironment()

if (env !== 'stage' && env !== 'dev') {
  Sentry.init({
    dsn: 'https://59f8702791915cd70a78e011a3a5854a@sentry.wb.ru/969',
    environment: env,
    integrations: [],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })

  import('@sentry/react').then((lazyLoadedSentry) => {
    Sentry.addIntegration(lazyLoadedSentry.replayIntegration())
    Sentry.addIntegration(lazyLoadedSentry.browserTracingIntegration())
  })
}

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(
  <BrowserRouter>
    <UserStateProvider>
      <AdminMenuUiStateProvider>
        <PromoPageStateProvider>
          <Provider value={rootStore}>
            <App />
          </Provider>
        </PromoPageStateProvider>
      </AdminMenuUiStateProvider>
    </UserStateProvider>
  </BrowserRouter>,
)
